import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState({
        username: null,
        role: null,
        permission: null
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const checkAuth = async () => {
            // const url = `${process.env.REACT_APP_URL}`
            console.log('triggering the checkAuth')
            try {
                const response = await axios.get(`${process.env.REACT_APP_URL}/auth/me`, {
                    withCredentials: true,
                });
                console.log(response.data, "here is the response")
                setUser({ username: response.data.username, role: response.data.role, permission: response.data.permission });
            } catch (error) {
                setUser(null);
            } finally {
                setLoading(false);
            }
        };
        checkAuth();
    }, []);

    const logout = async () => {
        try {
            await axios.post(`${process.env.REACT_APP_URL}/auth/logout`, {}, {
                withCredentials: true
            });
        } catch (error) {
            console.error("Logout error:", error);
        } finally {
            const theme = localStorage.getItem('theme'); // Save theme
            localStorage.clear(); // Clear everything
            if (theme) {
                localStorage.setItem('theme', theme); // Restore theme
            }
            setUser(null);
            // localStorage.clear();
        }
    };
    return (
        <AuthContext.Provider value={{ user, setUser, logout, loading }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
